// extracted by mini-css-extract-plugin
module.exports = {"legendPriceIconsRoot":"uhpGo5Mc","iconSpan":"REVfLD9L"};